export default "__VITE_ASSET__DHn4801Y__"